const SOURCE_LABEL_KEYS: Record<string, string> = {
  form: 'leads.detail.consent.sourceForm',
  whatsapp: 'leads.detail.consent.sourceWhatsapp',
  web: 'leads.detail.consent.sourceWeb',
  manual: 'leads.detail.consent.sourceManual',
  api: 'leads.detail.consent.sourceApi',
  voice_call: 'leads.detail.consent.sourceVoiceCall',
};

/**
 * Translate a `VoiceConsentSource` value into the i18n key that names it.
 *
 * The backend owns the enum and can grow it without the app shipping, so an
 * unknown value degrades to a generic label instead of leaking the raw enum or
 * dropping the caption — the date and the outcome still matter on their own.
 */
export function consentSourceLabelKey(source: string): string {
  return SOURCE_LABEL_KEYS[source] ?? 'leads.detail.consent.sourceUnknown';
}
